import { api } from "./api";

export const resourceHubApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllResourcePagination: builder.mutation({
      query: (data) => ({
        url: "/resourceManagement/getAllResourcePagination",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ResourceHub"],
    }),
    getResourceById: builder.query({
      query: (id) => ({
        url: `/resourceManagement/get/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "ResourceHub", id }],
    }),
    saveResource: builder.mutation({
      query: (data) => ({
        url: "/resourceManagement/saveResource",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ResourceHub"],
    }),
    updateResource: builder.mutation({
      query: ({ id, data }) => ({
        url: `/resourceManagement/update/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "ResourceHub", id }, "ResourceHub"],
    }),
    deleteResource: builder.mutation({
      query: (id) => ({
        url: `/resourceManagement/delete/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["ResourceHub"],
    }),
    viewResourceFile: builder.mutation({
      query: ({ resourceId, fileId }) => ({
        url: `/resourceManagement/file/view/${resourceId}`,
        method: "POST",
        body: { fileId },
      }),
      invalidatesTags: (result, error, { resourceId }) => [{ type: "ResourceHub", id: resourceId }],
    }),
    downloadResourceFile: builder.mutation({
      query: ({ resourceId, fileId }) => ({
        url: `/resourceManagement/file/download/${resourceId}`,
        method: "POST",
        body: { fileId },
      }),
      invalidatesTags: (result, error, { resourceId }) => [{ type: "ResourceHub", id: resourceId }],
    }),
    getResourcesCategorized: builder.mutation({
      query: (data) => ({
        url: `/resourceManagement/getResourcesCategorized`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ResourceHub"],
    }),
    getPendingResourceList: builder.mutation({
      query: (data) => ({
        url: "/resourceManagement/getPendingResourceList",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ResourceHub"],
    }),
    approveRejectResource: builder.mutation({
      query: ({ id, data }) => ({
        url: `/resourceManagement/approveReject/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "ResourceHub", id }, "ResourceHub"],
    }),
    enableDisableResource: builder.mutation({
      query: (id) => ({
        url: `/resourceManagement/enableDisable/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["ResourceHub"],
    }),
  }),
});

export const {
  useGetAllResourcePaginationMutation,
  useGetResourceByIdQuery,
  useLazyGetResourceByIdQuery,
  useSaveResourceMutation,
  useUpdateResourceMutation,
  useDeleteResourceMutation,
  useViewResourceFileMutation,
  useDownloadResourceFileMutation,
  useGetResourcesCategorizedMutation,
  useGetPendingResourceListMutation,
  useApproveRejectResourceMutation,
  useEnableDisableResourceMutation,
} = resourceHubApi;
